<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="8">
        <pie-simple ref="picEchart" />
      </el-col>
      <el-col :span="8">
        <bar-simple ref="barEchart" />
      </el-col>
      <el-col :span="8">
        <radar-simple ref="radarEchart" />
      </el-col>
    </el-row>

    <el-table
      v-loading="loading"
      :data="tableData"
      stripe
      height="220"
      style="width: 100%"
    >
      <el-table-column
        v-for="item in orderedKey"
        :key="item"
        :prop="item"
        :width="columnMap[item].width"
        :label="columnMap[item].label"
        :fixed="columnMap[item].fixed"
        align="center"
      ></el-table-column>
    </el-table>
  </div>
</template>

<script>
import LabExperiment2UserApi from "@/api/lab/labexperiment2user";
import LabLesson2UserApi from "@/api/lab/lesson2user";
import Json2excel from "custom-json2excel"; // 然后引入到需要使用的vue界面中
import PieSimple from "./components/PieSimple.vue";
import BarSimple from "./components/BarSimple.vue";
import RadarSimple from "./components/RadarSimple.vue";

export default {
  name: "labExperiment2UserList",
  components: {
    PieSimple,
    BarSimple,
    RadarSimple,
  },
  props: {
    lessonUid: {
      type: String,
      required: true,
      default: "",
    },
    lessonExpUid: {
      type: String,
      required: true,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      orderedKey: [],
      columnMap: {},
      lessonUserList: [], // 课堂成员列表
      lessonExperimentUserList: [], // 课堂实验成员记录列表
      totalScore: 0,
      radarIndicator: [],
      seriesData: [],
    };
  },
  watch: {
    lessonUid: {
      immediate: true,
      handler: function (uid) {
        this.getUserListByLessonUid(uid);
      },
    },
    lessonExpUid: {
      immediate: true,
      handler: function (uid) {
        this.getListByLessonExpUid(uid);
      },
    },
    tableData: {
      deep: true,
      immediate: true,
      handler: function () {
        this.refreshEchartsData();
      },
    },
  },
  methods: {
    getUserListByLessonUid(lessonUid) {
      if (lessonUid == null || lessonUid === "") {
        return;
      }

      this.loading = true;
      this.lessonUserList = [];
      LabLesson2UserApi.getList({
        lessonUid,
      })
        .then((list) => {
          this.lessonUserList = list;
          this.formatDataList();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getListByLessonExpUid(lessonExpUid) {
      if (lessonExpUid == null || lessonExpUid === "") {
        return;
      }

      this.loading = true;
      this.lessonExperimentUserList = [];
      LabExperiment2UserApi.getList({
        lessonExpUid,
      })
        .then((list) => {
          this.lessonExperimentUserList = list;
          this.formatDataList();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatDataList() {
      this.loading = true;
      let dataList = [];
      let orderedKey = ["username", "nickname"];
      let columnMap = {
        username: { label: "用户名", fixed: "left" },
        nickname: { label: "姓名", width: 100, fixed: "left" },
        status: { label: "状态", fixed: "right" },
      };
      let radarIndicator = [];
      let seriesData = [];

      let totalScore = 0;
      this.lessonUserList.map((lessonUser) => {
        let seriesRow = { value: [] };
        let row = {
          username: lessonUser.username,
          nickname: lessonUser.nickname,
          joinTime: lessonUser.joinTime,
          status: "未开始",
        };
        seriesRow.name = lessonUser.nickname;

        let lessonExperimentUser = this.lessonExperimentUserList.find(
          (item) => item.lessonUserUid === lessonUser.uid
        );
        if (lessonExperimentUser) {
          let report = [];
          try {
            report = JSON.parse(lessonExperimentUser.report).list;
          } catch (error) {
            console.warn(error);
          }
          report.map(({ goal, score, key, type }, index) => {
            if (!orderedKey.some((item) => item === key)) {
              orderedKey.push(key);

              let typeText = "题目";
              switch (type) {
                case "editor":
                  typeText = "问答题";
                  break;

                default:
                  console.warn(`other type：${type}`);
                  break;
              }
              totalScore += score;

              columnMap[key] = {
                label: `${index + 1}.${typeText}（${score}分）`,
                width: 136,
              };

              radarIndicator.push({
                name: `${index + 1}.${typeText}`,
                max: score,
              });
            }
            row[key] = goal;
            seriesRow.value.push(goal || 0);
          });

          switch (lessonExperimentUser.status) {
            case 0:
              row.status = "未提交";
              break;

            case 1:
              row.status = "未批阅";
              break;

            case 2:
              row.status = "已完成";
              seriesData.push(seriesRow);
              break;

            default:
              console.warn(`other status：${lessonExperimentUser.status}`);
              break;
          }

          row.startTime = lessonExperimentUser.startTime;
          row.submitTime = lessonExperimentUser.submitTime;
          row.score = lessonExperimentUser.score;
        }

        dataList.push(row);
      });

      orderedKey.push("score");
      orderedKey.push("status");
      this.orderedKey = orderedKey;

      columnMap.score = {
        label: `总成绩（${totalScore}分）`,
        width: 136,
      };
      this.columnMap = columnMap;

      this.totalScore = totalScore;
      this.radarIndicator = radarIndicator;
      this.seriesData = seriesData;

      this.tableData = dataList;

      this.loading = false;
    },
    refreshEchartsData() {
      this.refreshPicEchartData();
      this.refreshBarEchartData();
      this.refreshRadarEchartData();
    },
    refreshPicEchartData() {
      try {
        let { tableData } = this;
        if (tableData.length < 1) {
          return;
        }

        this.$refs.picEchart.refreshData([
          {
            name: "未开始",
            value: tableData.filter((item) => item.status === "未开始").length,
          },
          {
            name: "未提交",
            value: tableData.filter((item) => item.status === "未提交").length,
          },
          {
            name: "未批阅",
            value: tableData.filter((item) => item.status === "未批阅").length,
          },
          {
            name: "已完成",
            value: tableData.filter((item) => item.status === "已完成").length,
          },
        ]);
      } catch (error) {
        console.warn(error);
      }
    },
    refreshBarEchartData() {
      try {
        let { tableData, totalScore } = this;
        tableData = this.tableData.filter((item) => item.status === "已完成");

        if (totalScore < 1 || tableData.length < 1) {
          return;
        }

        this.$refs.barEchart.refreshData(
          [
            `0-${totalScore * 0.6}`,
            `${totalScore * 0.6}-${totalScore * 0.7}`,
            `${totalScore * 0.7}-${totalScore * 0.8}`,
            `${totalScore * 0.8}-${totalScore * 0.9}`,
            `${totalScore * 0.9}-${totalScore}`,
          ],
          [
            tableData.filter((item) => item.score < totalScore * 0.6).length,
            tableData.filter(
              (item) =>
                item.score >= totalScore * 0.6 && item.score < totalScore * 0.7
            ).length,
            tableData.filter(
              (item) =>
                item.score >= totalScore * 0.7 && item.score < totalScore * 0.8
            ).length,
            tableData.filter(
              (item) =>
                item.score >= totalScore * 0.8 && item.score < totalScore * 0.9
            ).length,
            tableData.filter((item) => item.score >= totalScore * 0.9).length,
          ]
        );
      } catch (error) {
        console.warn(error);
      }
    },
    refreshRadarEchartData() {
      try {
        if (this.radarIndicator.length < 1 || this.seriesData.length < 1) {
          return;
        }

        this.$refs.radarEchart.refreshData(
          this.radarIndicator,
          this.seriesData
        );
      } catch (error) {
        console.warn(error);
      }
    },
    download(name = "课堂实验成绩明细") {
      if (this.tableData.length < 1) {
        this.$message.warning("暂无数据");
        return;
      }

      let keyMap = {};
      for (let key in this.columnMap) {
        if (Object.hasOwnProperty.call(this.columnMap, key)) {
          let element = this.columnMap[key];
          keyMap[key] = element.label;
        }
      }

      const json2excel = new Json2excel({
        name,
        data: this.tableData,
        orderedKey: this.orderedKey,
        keyMap,
      });
      json2excel.generate();
    },
  },
};
</script>
